import { styled, StyledComponentProps } from '@material-ui/core';
import { ComponentProps, ComponentType } from 'react';

export const WbSidebarSpace = styled('div')(
  {
    flex: 1,
  },
  { name: 'WitboostSidebarSpace' },
) as ComponentType<ComponentProps<'div'> & StyledComponentProps<'root'>>;
